import { connect } from "react-redux";
import { VoxbayInitialStateDTO } from "../service/types";
import { RootState, TypedDispatch } from "../../../../redux/store";
import {
  addVoxbayAgent,
  deactivateVoxbay,
  voxbayClickToCall,
  voxbayConnect,
} from "../service/voxbaySlice";
import VoxbayDetails from "../components/VoxbayDetails/VoxbayDetails";
import { getStaffList } from "../../Manage/ManageStaff/service/Staffslice";

interface DispatchProps {
  VoxbayConnect(data: any): void;
  AddVoxbayAgent(data: any): void;
  DeactivateVoxbay(id: string): void;
  GetStaffList(id: string): void;
  VoxbayClickToCall(data: any): void;
}

const mapStateToProps = (state: RootState): VoxbayInitialStateDTO => {
  return {
    voxbayConnectionLoading: state.voxbay.voxbayConnectionLoading,
    voxbayConnectionSuccess: state.voxbay.voxbayConnectionSuccess,
    voxbayConnectionError: state.voxbay.voxbayConnectionError,
    addVoxbayLoading: state.voxbay.addVoxbayLoading,
    addVoxbaySuccess: state.voxbay.addVoxbaySuccess,
    addVoxbayError: state.voxbay.addVoxbayError,
    uninstallVoxbayLoading: state.voxbay.uninstallVoxbayLoading,
    uninstallVoxbaySuccess: state.voxbay.uninstallVoxbaySuccess,
    uninstallVoxbayError: state.voxbay.uninstallVoxbayError,
    voxbayWidgetShow: state.voxbay.voxbayWidgetShow,
    voxbayWidgetNumber: state.voxbay.voxbayWidgetNumber,
    voxbayClickToCallLoading: state.voxbay.voxbayClickToCallLoading,
    voxbayClickToCallSuccess: state.voxbay.voxbayClickToCallSuccess,
    voxbayClickToCallError: state.voxbay.voxbayClickToCallError,
    voxbayAddLeadForUnknownLoading: state.voxbay.voxbayAddLeadForUnknownLoading,
    voxbayAddLeadForUnknownSuccess: state.voxbay.voxbayAddLeadForUnknownSuccess,
    voxbayAddLeadForUnknownError: state.voxbay.voxbayAddLeadForUnknownError,
    voxbayAddLeadForUnknownData: state.voxbay.voxbayAddLeadForUnknownData,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    VoxbayConnect: (data: any) => {
      dispatch(voxbayConnect(data));
    },
    AddVoxbayAgent: (data: any) => {
      dispatch(addVoxbayAgent(data));
    },
    DeactivateVoxbay: (id: string) => {
      dispatch(deactivateVoxbay(id));
    },
    GetStaffList: (id: string) => {
      dispatch(getStaffList(id));
    },
    VoxbayClickToCall: (data: any) => {
      dispatch(voxbayClickToCall(data));
    },
  };
};

export interface VoxbayProps extends VoxbayInitialStateDTO, DispatchProps {}
export const VoxbayComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(VoxbayDetails);
